module.exports = __webpack_public_path__ + "img/logo2.90d43629.png";